// extracted by mini-css-extract-plugin
export default {"Bluecheese":"#615CFF","White":"#FFFFFF","Black":"#333D47","radioGroup":"G53fc47"};